/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Phone_MaxInputs */

const vi_validation_phone_max = /** @type {(inputs: Validation_Phone_MaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số điện thoại tối đa 20 ký tự`)
};

/**

* @param {Validation_Phone_MaxInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_phone_max = /** @type {((inputs?: Validation_Phone_MaxInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Phone_MaxInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_phone_max(inputs)
});